interface AccessLevelLike {
  active?: boolean;
}

interface PurchaseAccessLike {
  studyAccess?: AccessLevelLike;
  allLevelStudyAccess?: AccessLevelLike;
}

interface ReferralOfferLike {
  offerExpiresAt: number;
}

type ReferralTrialLike = object;

export interface ReferralOfferEligibilityInput {
  offer?: ReferralOfferLike;
  referralTrial?: ReferralTrialLike;
  purchaseAccess?: PurchaseAccessLike;
  now?: number;
}

const hasPaidStudyAccess = (purchaseAccess?: PurchaseAccessLike) =>
  purchaseAccess?.studyAccess?.active === true ||
  purchaseAccess?.allLevelStudyAccess?.active === true;

export const isReferralOfferClaimable = ({
  offer,
  referralTrial,
  purchaseAccess,
  now = Date.now(),
}: ReferralOfferEligibilityInput): boolean =>
  !!offer &&
  !referralTrial &&
  !hasPaidStudyAccess(purchaseAccess) &&
  now < offer.offerExpiresAt;
